module.exports = "<page-preloader></page-preloader><div class=\"list-item\" *ngFor=\"let invoice of invoices\"><div class=\"layout-row\"><div class=\"flex content\"><div class=\"title\">{{invoice.timestamp | toLocalDate }}</div><small><div>Invoice Number: {{invoice.invoiceId}} </div><div>{{invoice.location.name}}</div></small></div><div class=\"flex-nogrow results amount\" [class.positive-number]=\"invoice.total &gt; 0\" [class.negative-number]=\"invoice.total &lt;= 0\">{{ invoice.total | currency:'USD':true }}</div></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/customers/customer-invoices/customer-invoices.component.pug
// module id = 1035
// module chunks = 0